module.exports = __webpack_public_path__ + "img/r3.063df6fb.png";